import { useEffect, useRef } from "react";
import AnchoredPanel from "../../../../GlobalComponents/AnchoredPanel/AnchoredPanel";
import { ESG_PILLARS } from "../../../../../_constants/esgPillars";

/**
 * The ESG pillars a module tag can sit under, anchored under the cell that asked. Not a modal, like every other
 * picker in the grid.
 *
 * @param {object} props
 * @param {{ current: HTMLElement|null }} props.anchorRef
 * @param {string} props.moduleTag
 * @param {string} [props.current] the tag's pillar, when it has one
 * @param {string} [props.error] why the last pick was not saved
 * @param {boolean} [props.saving]
 * @param {(esgPillar: string) => void} props.onPick
 * @param {() => void} props.onClose
 */
export default function EsgPillarPicker({ anchorRef, moduleTag, current, error, saving, onPick, onClose }) {
  const firstOptionRef = useRef(null);

  useEffect(() => {
    if (firstOptionRef.current) firstOptionRef.current.focus();
  }, []);

  return (
    <AnchoredPanel
      anchorRef={anchorRef}
      onClose={onClose}
      className="kgb-picker kgb-esg-picker"
      role="group"
      aria-label={`ESG pillar of ${moduleTag}`}
    >
      <p className="kgb-picker-title">ESG pillar of “{moduleTag}”</p>
      {ESG_PILLARS.map((option, index) => (
        <button
          key={option.value}
          type="button"
          ref={index === 0 ? firstOptionRef : null}
          className="kgb-picker-option"
          aria-pressed={option.value === current}
          disabled={saving}
          onClick={() => onPick(option.value)}
        >
          {option.label}
        </button>
      ))}
      <p className="kgb-esg-note">Applies to every KPI tagged “{moduleTag}”.</p>
      {error ? (
        <p className="kgb-esg-error" role="alert">
          {error}
        </p>
      ) : null}
    </AnchoredPanel>
  );
}
